export function getCookie(name: string): string {
  const ca: string[] = document.cookie.split(';');
  const cookieName = `${name}=`;

  for (const rawEntry of ca) {
    const c = rawEntry.replace(/^\s+/g, '');
    if (c.indexOf(cookieName) === 0) {
      return c.substring(cookieName.length, c.length);
    }
  }

  return '';
}
